import { getDeployEnv } from "./mediaPaths";

export function getSubscriptionDeployStage() {
  return String(getDeployEnv()).trim().toLowerCase() === "prod" ? "Prod" : "Test";
}

export function getSubscriptionPublicRootPrefix(stage = getSubscriptionDeployStage()) {
  return `MyHub/${stage}/subscription/public`;
}

export const SUBSCRIPTION_CATALOG_CONFIG = {
  cdnRoot: "https://media.ziniz.online",
  get rootManifestPath() {
    return `${getSubscriptionPublicRootPrefix()}/manifest.json`;
  },
};

export const SUBSCRIPTION_ROUTE_REQUIREMENTS = [
  { prefix: "/product-builder", moduleId: "catalog" },
  { prefix: "/hubSettings", moduleId: "settings", roles: ["owner"] },
  { prefix: "/dashboard", moduleId: "orders" },
  { prefix: "/gallery", moduleId: "gallery", limitId: "imagesPerItem" },
  { prefix: "/notebook", moduleId: "notebook" },
  {
    prefix: "/biz/create",
    moduleId: "store",
    limitId: "stores",
    roles: ["owner"],
  },
  { prefix: "/biz", moduleId: "store", limitId: "stores" },
  { prefix: "/hub", moduleId: "store" },
];

export function getSubscriptionRouteRequirement(pathname) {
  return SUBSCRIPTION_ROUTE_REQUIREMENTS.find(
    ({ prefix }) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  ) || null;
}
